module.exports = __webpack_public_path__ + "img/user-g.142423f8.svg";